import { BaseModel, Default, EndOfDate, FormattedDateString, StartOfDate } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
import { SplitPartDto } from './commission-salesperson-scheme-form.dto';

export class CommSchemeSetupCreateDto extends BaseModel {
  @Expose()
  businessUnitId!: number;

  @Expose()
  @Default('')
  code!: string;

  @Expose()
  @Default('')
  name!: string;

  @Expose()
  @Default(true)
  isActive!: boolean;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  startDate!: string;

  @Expose()
  @Type(() => Date)
  @EndOfDate()
  @FormattedDateString()
  @Default(null)
  endDate!: string;

  @Expose()
  @Type(() => SplitPartDto)
  tiers!: SplitPartDto[];

  @Expose()
  @Type(() => SplitPartDto)
  parties!: SplitPartDto[];

  @Expose()
  remarks!: string;

  @Expose()
  @Default(false)
  isDefault!: boolean;
}

export class CommSchemeSetupUpdateDto extends CommSchemeSetupCreateDto {
}





